
import PlatformCard from './PlatformCard';
export default PlatformCard;    
